<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>Add Text</ion-title>
    <ion-buttons slot="end">
      <ion-title style="cursor: pointer;" size="large" (click)="goToMenu()">Menu</ion-title>
      <!-- <ion-title style="cursor: pointer;" size="large" (click)="goToAdminPage()">Admin</ion-title> -->
      <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title>
  </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container>
    <form [formGroup]="addTextForm" (ngSubmit)="onSubmit()" class="addtext-form">
    <!-- <form [formGroup]="addTextForm"> -->
      <ion-list>
      <ion-item class="form-item">
        <!-- <ion-label position="floating">Message:</ion-label> -->
        <ion-input 
          formControlName="message"
          type="text" 
          required 
          Placeholder = "Enter your text here ..."
          [(ngModel)]="formData.message" 
          name="message">
          
        </ion-input>
        <!-- <div *ngIf="addTextForm.get('message')?.invalid && addTextForm.get('message')?.touched">
          <span class="inferencing-error-message" *ngIf="addTextForm.get('message')?.hasError('required')">Message is required field.</span>
        </div> -->
      </ion-item>  
      <ion-item class="form-item">
        <ion-label position="floating">Language:</ion-label>
        <ion-select name="lang" formControlName="lang" required>
          <ion-select-option value="nl" selected>Dutch</ion-select-option>
          <ion-select-option value="english">English</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item class="form-item">
        <ion-label position="floating">Type:</ion-label>
        <ion-select name="lang" formControlName="type" required>
          <ion-select-option value="text" selected>Text</ion-select-option>
          <ion-select-option value="surveyforms" selected>SurveyForms</ion-select-option>
          <ion-select-option value="character">Character</ion-select-option>
          <ion-select-option value="number">Number</ion-select-option>
          <ion-select-option value="outbound">Outbound</ion-select-option>
        </ion-select>
      </ion-item>

      
  

      <ion-button type="submit" expand="block" class="submit-button" [disabled]="!addTextForm.valid">Add Text</ion-button>
    </ion-list>
    </form>
  </ng-container>
</ion-content>
